import React, { useEffect, useRef, useState } from "react"
import CustomModal from "../basics/interface/CustomModal"
import { generalStyles } from "../styles/styles"

// Version V2 (CustomModal) de AddTransactionModal pour la fiche atelier —
// saisie de la raison d'une nouvelle transaction. Props : closeModal, addTransaction.
const AddTransactionModalV2 = ({ closeModal, addTransaction }) => {
	const [raison, setRaison] = useState("")
	const inputRef = useRef(null)

	useEffect(() => {
		if (inputRef.current) inputRef.current.focus()
	}, [])

	const clickOk = () => {
		addTransaction(raison)
		closeModal()
	}

	return (
		<CustomModal
			title={"Nouvelle transaction"}
			onClose={closeModal}
			buttons={[
				{ title: "Fermer", styleName: "secondary", onClick: closeModal },
				{
					title: "Ajouter",
					styleName: "primary",
					onClick: clickOk,
					disabled: raison === "",
				},
			]}
		>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Raison</label>
				<input
					ref={inputRef}
					type="text"
					style={generalStyles.input}
					value={raison}
					onChange={(e) => setRaison(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter" && raison !== "") clickOk()
					}}
				/>
			</div>
		</CustomModal>
	)
}

export default AddTransactionModalV2
